// ─────────────────────────────────────────────────────────────
// ABERCAL — "Dreams, Delivered" GALLERY CONFIG
// Owner edit guide: add one line to the array below. Five types:
//
//   PHOTO:       { type: "photo",       title: "...", src: "IMAGE_URL", caption: "..." }
//   VIDEO:       { type: "video",       title: "...", src: "VIDEO_URL", poster: "IMAGE_URL" }  // hover to play
//   WEBSITE:     { type: "website",     title: "...", url: "https://...", thumbnail: "IMAGE_URL" } // live, clickable, opens new tab
//   PRIVATE:     { type: "private",     title: "...", src: "IMAGE_URL" }  // confidential — no link, no URL shown, locked preview
//   INSPIRATION: { type: "inspiration", title: "...", url: "https://...", thumbnail: "IMAGE_URL" } // opens the live site INSIDE a dialog (domain never shown, no new tab)
//
// Delete a line to remove an item. Empty the array to show the elegant empty state.
// Do NOT fabricate client work — an empty gallery beats a fake full one.
// ─────────────────────────────────────────────────────────────

export const galleryItems = [
  {
    type: "inspiration",
    title: "Websites That Move",
    url: "https://abercaliainwebsites.biz/",
    thumbnail: "/websites-that-move-thumb.jpg",
  },
  {
    type: "website",
    title: "Rodeo Cut Studio — AI Rodeo Video Platform",
    url: "https://rodeocutstudio.com/",
    thumbnail: "/rodeocut-thumb.jpg",
  },
  {
    type: "website",
    title: "West Springs Optometry",
    url: "https://westspringsoptometry.com/",
    thumbnail: "/westsprings-thumb.jpg",
  },
  {
    type: "private",
    title: "Private Client Platform",
    src: "/private-site-1.jpg",
  },
];
